import { Component, computed, input } from '@angular/core';
import { InnogyComponentRendering } from '@core/jss-models';
import {
  ExtendedUspsSectionComponent,
  type ExtentedUsp,
} from '@content/ui/extended-usps';
import { TextField, type LinkField, type RichTextField } from '@core/jss-proxy';
import { getDroplinkValue, getField } from '@core/jss-utils';
import {
  computedContentSectionTheme,
  ContentSectionComponent,
  ContentSectionThemes,
} from '@core/content-section';
import type { IconIcon } from '@essent/current-web';

@Component({
  selector: 'wl-extended-usps-container',
  templateUrl: './extended-usps.container.component.html',
  standalone: true,
  imports: [ExtendedUspsSectionComponent, ContentSectionComponent],
})
export class ExtendedUspsContainerComponent {
  readonly rendering = input.required<InnogyComponentRendering>();
  readonly theme = computedContentSectionTheme(this.rendering);
  readonly fields = computed(() => this.rendering().fields);

  readonly uid = computed(() => this.rendering().uid);

  readonly title = computed(() => getField<TextField>(this.fields(), 'title'));

  readonly introduction = computed(() =>
    getField<RichTextField>(this.fields(), 'introduction')
  );

  readonly callToAction = computed(() =>
    getField<LinkField>(this.fields(), 'callToAction')
  );

  readonly numberOfExtendedUsps = computed(() =>
    this.rendering()?.componentName === 'ExtendedUsps4Section' ? 4 : 3
  );

  readonly extendedUsps = computed<ExtentedUsp[]>(() =>
    Array.from({ length: this.numberOfExtendedUsps() }, (_, i) =>
      this.#buildExtendedUsp(i + 1)
    )
  );

  readonly inverted = computed(() => {
    const theme = this.theme();

    return (
      theme === ContentSectionThemes.BRAND ||
      theme === ContentSectionThemes.DARK
    );
  });

  #buildExtendedUsp(index: number): ExtentedUsp {
    const fields = this.fields();

    return {
      icon: getDroplinkValue<IconIcon>(fields, `usp${index}Icon`),
      title: getField<TextField>(fields, `usp${index}Title`),
      description: getField<TextField>(fields, `usp${index}Description`),
    };
  }
}
